import { type FC } from 'react';
import cn from 'classnames';

import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import startPng from '/img/modals/stars-1.png';
import startWebp from '/img/modals/stars-1.webp';

const Background: FC = () => {
  return (
    <div className={cn('absolute top-0 left-0 w-full h-full', css.mask)}>
      <Picture
        className="absolute top-0 left-0 w-full aspect-[856/800]"
        img={startPng}
        webp={startWebp}
        alt="stars"
      />
      <div className={css.elipse}></div>
      <div className={css.radialGradient}></div>
    </div>
  );
};

export { Background };
